import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "quick-dashboard" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "column q-ml-md"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "q-mb-sm float-left" }, "Add a new equipment to the table", -1 /* HOISTED */)
const _hoisted_6 = { class: "row justify-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_8 = { class: "column q-mt-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!
  const _component_EquipmentSelector = _resolveComponent("EquipmentSelector")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "filter-text-box",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        type: "text",
        placeholder: "Keyword Search",
        "data-test": "keyword-search-quickdashboard",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilterTextBoxChanged()))
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.filter]
      ]),
      _createVNode(_component_q_icon, {
        class: "search",
        name: "search"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ag_grid_vue, {
        style: {"width":"81%","height":"620px"},
        class: "ag-theme-alpine",
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.rowData,
        "default-col-def": _ctx.defaultColDef,
        "data-test": "ag-grid-quickdashboard",
        "row-height": 45,
        onGridReady: _ctx.onGridReady,
        onCellValueChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCellValueChanged($event)))
      }, null, 8 /* PROPS */, ["column-defs", "row-data", "default-col-def", "onGridReady"]),
      (!_ctx.isUserUnknownOrGuestOrOnshore())
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_card, { class: "q-pa-md" }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_EquipmentSelector),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_btn, {
                    rounded: "",
                    class: "action-button q-mt-sm",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewEquipmentToTable(false)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_btn, {
                outline: "",
                rounded: "",
                "no-caps": "",
                label: "Add a free row to the table",
                class: "action-button save-dashboard-button",
                "data-test": "onUpdate-quickdashboard",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewEquipmentToTable(true)))
              }),
              _createVNode(_component_q_btn, {
                outline: "",
                rounded: "",
                "no-caps": "",
                label: "Save modifications",
                class: "action-button save-dashboard-button q-mt-md",
                "data-test": "onUpdate-quickdashboard",
                onClick: _ctx.onUpdate
              }, null, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_q_btn, {
                outline: "",
                rounded: "",
                "no-caps": "",
                label: "Reset modifications",
                class: "main-button save-dashboard-button q-mt-md q-ml-lg",
                "data-test": "onReset-quickdashboard",
                onClick: _ctx.onResetData
              }, null, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_q_btn, {
                outline: "",
                rounded: "",
                "no-caps": "",
                label: "Export to excel",
                class: "main-button save-dashboard-button q-mt-md q-ml-lg",
                "data-test": "onExport-quickdashboard",
                onClick: _ctx.onExportData
              }, null, 8 /* PROPS */, ["onClick"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}